import { render, staticRenderFns } from "./ItemSidebarQuestion.vue?vue&type=template&id=07506ae0"
import script from "./ItemSidebarQuestion.vue?vue&type=script&lang=js"
export * from "./ItemSidebarQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports